var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323.457,
    height: 278.977,
    viewBox: "0 0 323.457 278.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#858585}.cls-4{fill:#8e8e8e}.cls-5{fill:#8b8b8b}.cls-6{fill:#898989}.cls-7{fill:#8a8a8a}.cls-8{fill:#888}.cls-9{fill:#878787}.cls-10{fill:#8c8c8c}.cls-13{fill:#f5f7ff}.cls-14{fill:#dfe4ff}.cls-15{fill:#fbfbfb}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "empty_box-01",
    transform: "translate(-88.33 -114.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4291",
    "data-name": "Path 4291",
    d: "M374.83 372.93a118 118 0 0 1 30.94 4 15.432 15.432 0 0 1 3.28 1.1c1.24.64 3.17 1 2.65 3a4 4 0 0 1-3.18 2.84 154.718 154.718 0 0 1-21.94 4c-19.93 2.17-39.88 3.76-59.95 4.33-7.93.23-15.92.23-23.86.74-24.77 1.61-49.56.7-74.34 1-16.63.19-33.23-.92-49.84-1.25-19.51-.4-39-2.12-58.45-4-9.16-.87-18.47-1.72-27.32-4.74-1.85-.63-4.44-.91-4.49-3.28 0-2.73 2.87-3 4.75-3.57a128.621 128.621 0 0 1 25.41-4.1c7.13-.55 7.55-.79 7.55-7.77v-72c0-1.77-.57-3.69.79-5.28 2.24 1.93 1.64 4.58 1.64 7v72.45c0 8.67 2.55 11.37 11.1 11.84 2.16.12 4.33.07 6.49.07H351c8.54.05 17.41 1.38 23.83-6.38z",
    style: {
      fill: "#2a4dff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4292",
    "data-name": "Path 4292",
    d: "M374.83 372.93c-2.42 5.75-6.74 8-13 8q-111.21-.15-222.41-.07c-8.86 0-12.42-3.57-12.44-12.39q-.09-40.23-.16-80.45c6.08-6.92 14-11.66 20.91-17.62 5.15-4.46 10.88-8.26 16-12.81 3.85-3.44 7.84-4.71 13-4.68 32 .23 64 .11 96 .11q27.6 0 55.21-.05a10.64 10.64 0 0 1 7.27 2.46q18.42 14.93 37.07 29.56c2.33 1.82 2.64 3.91 2.64 6.51q-.13 40.7-.09 81.43z",
    style: {
      fill: "#838484"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4293",
    "data-name": "Path 4293",
    className: "cls-3",
    d: "M194.35 137.58c-5.83.12-14.35-7.08-15.16-12.52-.44-3 .72-5.27 3.87-5.06s4.74-1.23 6.77-3.08c3.38-3.07 6.13-2.47 8.25 1.68.78 1.52 1.37 1.84 3 1.58 3.37-.54 6.76-.11 7.38 3.91.55 3.58-2 5.81-5.16 7-2.43.93-5 1.32-5.55 4.65-.32 1.62-2.41 1.51-3.4 1.84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4294",
    "data-name": "Path 4294",
    className: "cls-4",
    d: "M351.87 153.62c-1.95-.7-2.42-2.64-2.93-4.29-.66-2.16-4.33-4.89-1.63-6.28 3.19-1.64 3.22 3.06 4.66 4.94a10 10 0 0 1 1.62 3.62c.29 1.12-.43 1.86-1.72 2.01z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4295",
    "data-name": "Path 4295",
    className: "cls-5",
    d: "M357.87 196.78a22.87 22.87 0 0 1-4 7.39 1.57 1.57 0 0 1-2.17.42 1.63 1.63 0 0 1-.49-2.18q1.88-3.71 3.86-7.35a1.43 1.43 0 0 1 2-.73c.86.42.93 1.24.8 2.45z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4296",
    "data-name": "Path 4296",
    className: "cls-6",
    d: "M240.83 168.07c-.15 1-.93 2-1.94 1.53a24.54 24.54 0 0 1-7.48-5.67c-.84-.92-.22-1.91.91-2.28s8.44 5.03 8.51 6.42z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4297",
    "data-name": "Path 4297",
    className: "cls-7",
    d: "M353.68 161.28c-.15-.85-.1-1.7.83-2.06a1.63 1.63 0 0 1 2.28 1.22c.75 2.53 1.36 5.1 2 7.66a1.89 1.89 0 0 1-1.23 2.4c-1.27.46-1.82-.56-2.07-1.51-.68-2.55-1.22-5.13-1.81-7.71z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4298",
    "data-name": "Path 4298",
    className: "cls-8",
    d: "M336.57 129.1c3 2 5.92 4 7.4 7.22a1.29 1.29 0 0 1-2 1.6 47.279 47.279 0 0 1-6.84-6.43c-.91-1.07.03-2.05 1.44-2.39z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4299",
    "data-name": "Path 4299",
    className: "cls-6",
    d: "M322.25 123.78c2.56.77 7.45-.42 7.14 3s-4.36 0-6.72.36a3.3 3.3 0 0 1-1 0c-1.39-.17-3.6.3-3.49-1.68.13-2.46 2.52-1.34 4.07-1.68z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4300",
    "data-name": "Path 4300",
    className: "cls-5",
    d: "M247.48 171.89c1.76 1.3 4.28 3.11 6.75 5a1.05 1.05 0 0 1 0 1.7 2.23 2.23 0 0 1-1.77.48 25 25 0 0 1-7.29-4.95 2.26 2.26 0 0 1-.19-1.8c.21-.71.84-.96 2.5-.43z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4301",
    "data-name": "Path 4301",
    className: "cls-8",
    d: "M268.85 186.65c-.31 1.34-1.37 1.89-2.23 1.34-2.78-1.77-6.76-2.18-7.82-6-.29-1 1.37-1.44 2.26-.95 2.44 1.35 4.78 2.88 7.12 4.41.35.27.48.85.67 1.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4302",
    "data-name": "Path 4302",
    className: "cls-6",
    d: "M298.79 201.93c-.25 1-.82 1.66-1.68 1.69a3.82 3.82 0 0 1-1.84-.58c-2.48-1.35-5.74-1.48-7.17-4.43-.12-.25.71-1.37 1.06-1.34 3.35.21 6 2.27 8.92 3.62.36.17.52.75.71 1.04z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4303",
    "data-name": "Path 4303",
    className: "cls-9",
    d: "M326.35 212.22c-.5-.05-2.13-.15-3.75-.37-1.33-.18-2.86-.57-2.69-2.23.18-1.86 1.78-1.48 3.07-1.3 1.62.23 3.23.48 4.84.73 1.42.21 3.37.12 2.94 2.26-.32 1.63-1.98 1.33-4.41.91z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4304",
    "data-name": "Path 4304",
    className: "cls-8",
    d: "M312.12 126.68c-.39 2-2 2.45-3.39 2.57-2.46.22-5.29 4.77-6.6 1.65-1.39-3.33 3.64-3.59 6.05-4.9 1.36-.75 3.08-1.76 3.94.68z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4305",
    "data-name": "Path 4305",
    className: "cls-10",
    d: "M275.41 177.59c-.6 2.5-1.05 4.62-1.63 6.69-.28 1-.9 1.92-2.14 1.53a1.8 1.8 0 0 1-1.18-2.4c.52-2.1 1-4.21 1.64-6.27.34-1.08.88-2.36 2.44-1.71a1.6 1.6 0 0 1 .87 2.16z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4306",
    "data-name": "Path 4306",
    className: "cls-5",
    d: "M276.64 170.63c-.75.13-1.44-.21-1.5-.88-.3-3.29 1.63-5.9 2.9-8.69a1.39 1.39 0 0 1 2.08-.64c1.24.8.87 1.92.37 3-.8 1.8-1.53 3.63-2.27 5.46-.31.82-.67 1.54-1.58 1.75z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4307",
    "data-name": "Path 4307",
    className: "cls-6",
    d: "M227.46 157.79c-.53 1.67-1.73 1.88-3 1a55.336 55.336 0 0 1-5.67-4.69c-1.11-1.05-1.28-2.39.61-3 1.13-.34 8.1 5.48 8.06 6.69z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4308",
    "data-name": "Path 4308",
    className: "cls-7",
    d: "M298.34 135.32c.11 1-5.88 7.53-6.9 7.43a1.41 1.41 0 0 1-1.26-2.13 16.32 16.32 0 0 1 5.95-6.49c1.03-.65 1.87.04 2.21 1.19z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4309",
    "data-name": "Path 4309",
    className: "cls-4",
    d: "M268 197.26c1.11-1.82-.77-6.29 2.84-5.9 2.45.27.95 4.25.63 6.53-.2 1.39.22 4-2.28 3.55-1.88-.32-1.05-2.44-1.19-4.18z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4310",
    "data-name": "Path 4310",
    className: "cls-6",
    d: "M340.12 212.13c-1.91 0-3.39.39-3.63-1.19s1.11-1.71 2.29-2c1.93-.48 3.81-1.13 5.72-1.7 1-.3 2.09-.56 2.63.58.69 1.48-.48 2.13-1.58 2.53-2.02.74-4.09 1.34-5.43 1.78z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4311",
    "data-name": "Path 4311",
    className: "cls-6",
    d: "M278.82 246.26c.05.91-.23 1.45-.92 1.71a1.64 1.64 0 0 1-2.12-.72 22 22 0 0 1-2.88-7.25c-.15-.82 0-1.76 1-1.88a1.94 1.94 0 0 1 1.66.64c1.23 2.53 2.26 5.11 3.26 7.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4312",
    "data-name": "Path 4312",
    className: "cls-9",
    d: "M288.59 148.16c-1.56 2.5-3 4.89-4.56 7.23a1.31 1.31 0 0 1-1.76.42 1.39 1.39 0 0 1-.7-2.05c1.28-2.32 2.57-4.62 3.95-6.86a1.44 1.44 0 0 1 2.16-.47c.44.34.58 1.07.91 1.73z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4313",
    "data-name": "Path 4313",
    className: "cls-7",
    d: "M283.47 194.92a1.78 1.78 0 0 1-1.84 1.31c-1.79 0-8.53-4.09-8.53-5.25 0-1 .81-1.8 1.5-1.56a26.56 26.56 0 0 1 8.59 4.61c.2.16.19.58.28.89z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4314",
    "data-name": "Path 4314",
    className: "cls-3",
    d: "M356.71 182.33c.66-2-1.21-5.5 1.62-5.54s1.62 3.49 1.55 5.41 1.47 5.68-1.83 5.58c-2.64-.09-.6-3.64-1.34-5.45z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4315",
    "data-name": "Path 4315",
    className: "cls-7",
    d: "M314.49 207.63c-.14.31-.19.71-.42.88-2 1.54-3.79.15-5.56-.46s-4-.54-4.95-2.73c-.09-.21.15-.69.37-.86 2.18-1.6 4.11.1 6 .67 1.63.49 3.77.38 4.56 2.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4316",
    "data-name": "Path 4316",
    className: "cls-10",
    d: "M269 226c0-1.81.08-3.79 1.2-3.32 3.46 1.43 2.1 5.26 3.15 8 .46 1.19-.17 2.85-1.44 2.33-3.45-1.42-1.86-5.13-2.91-7.01z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4317",
    "data-name": "Path 4317",
    d: "M271 212.17a9.727 9.727 0 0 1 0 1.22c-.26 1.47.83 4-1.57 4-2.2 0-1.32-2.59-1.65-4.08a2 2 0 0 1 0-1c.5-1.87-1.32-5.36 1.61-5.33s.98 3.54 1.61 5.19z",
    style: {
      fill: "#838383"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4318",
    "data-name": "Path 4318",
    className: "cls-10",
    d: "M213 148.61c-1.84-1-3.84-2-4.41-4.28-.18-.74.71-1.61 1.66-1.41a5.89 5.89 0 0 1 4.43 4.18c.25.69-.59 1.44-1.68 1.51z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4319",
    "data-name": "Path 4319",
    d: "M251 289.65c38.16 0 76.31.08 114.47-.09 4.5 0 5.89 1.08 5.84 5.76-.24 24.32-.1 48.65-.11 73 0 7.28-1.55 8.87-8.72 8.88H139.05c-6.83 0-8.85-2.05-8.86-9 0-24.49.1-49-.12-73.47 0-4.41 1.54-5.14 5.46-5.12 38.47.1 76.98.04 115.47.04z",
    style: {
      fill: "#fefefe"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    "data-name": "Path 4320",
    className: "cls-13",
    d: "M286 256.15h41.2c2.29 0 2.78 1.08 2.76 3.07-.06 8-.08 16 0 24 0 2.2-.88 3-3 2.86-.83-.06-1.67 0-2.5 0-49 0-98-.08-147 .11-4.73 0-5.88-1.42-5.65-5.86.35-6.81.2-13.65.05-20.48-.07-2.81.86-3.73 3.7-3.73q51 .12 102 0c2 0 3.45.38 4.59 2.21.91 1.45 2 4.07 3.85 3.23 2.91-1.28-1-3.28 0-5.41z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    "data-name": "Path 4321",
    className: "cls-14",
    d: "m333 258 34.26 27.44c-4.77 1.07-8.83.51-12.84.58-6 .11-11.94 0-17.91 0-2 0-3.58-.07-3.54-2.8.13-7.91.03-15.82.03-25.22z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    "data-name": "Path 4322",
    className: "cls-14",
    d: "M167.92 258.6c.82 8.61.82 16.22.89 23.84 0 2.92-1.12 3.66-3.83 3.63-9.98-.07-19.91-.07-31.37-.07z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4323",
    "data-name": "Path 4323",
    className: "cls-15",
    d: "M184.34 122.19c3.78.19 10.8 6.33 11.5 10 .44 2.32-.66 2.94-2.74 2.79-3.85-.28-10.36-5.89-11.1-9.63-.38-1.93-.06-3.35 2.34-3.16z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4324",
    "data-name": "Path 4324",
    className: "cls-15",
    d: "M202.82 122.72c1.23.21 3.37-.1 3 2-.5 3.29-3.34 4.25-6.17 4.82a2.61 2.61 0 0 1-3.26-2.3c-.33-2.05 3.23-4.56 6.43-4.52z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    "data-name": "Path 4325",
    d: "M193.88 124.67c-1.09-1.6-4.06-1.67-3.65-4.15a3.36 3.36 0 0 1 3.74-2.58c2 .15 2.17 1.77 2 3.28-.18 1.36-.21 2.95-2.09 3.45z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4326",
    "data-name": "Path 4326",
    d: "M250.86 327.77c-10 0-20 .05-30 0-5 0-9.06-2.09-11.36-6.75-2-4.11-1.43-8.1 1.11-11.79 2.74-4 6.93-5 11.4-5 19.48-.05 39-.1 58.43 0 7.71 0 12.63 4.85 12.65 11.83s-5 11.54-12.8 11.66c-9.78.16-19.6.05-29.43.05z",
    style: {
      fill: "#858686"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4327",
    "data-name": "Path 4327",
    d: "M250.86 263h23c5.83 0 9.13 3 9.24 8.15.11 4.76-3.11 8.37-8.56 8.44q-23.73.3-47.47 0c-5.57-.09-9.08-4.2-8.69-9 .37-4.51 4.11-7.54 9.5-7.58q11.475-.015 22.98-.01z",
    style: {
      fill: "#848484"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4328",
    "data-name": "Path 4328",
    d: "M291.22 264.82a16.7 16.7 0 0 1 6.69 6.42c.72 1.28-.84 2.27-2 1.63a19.31 19.31 0 0 1-6.31-6c-.73-1.1.14-1.78 1.62-2.05z",
    style: {
      fill: "#888a8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    "data-name": "Path 4329",
    d: "M307.92 278.08c.09 1.29-.49 2-1.39 1.86-2-.32-3.87-1.15-4.73-3.1a1.29 1.29 0 0 1 1.57-1.79 6.75 6.75 0 0 1 4.55 3.03z",
    style: {
      fill: "#85878a"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4330",
    "data-name": "Path 4330",
    className: "cls-13",
    d: "M251 307.87h29.46c5.88 0 9.28 3 9.44 8s-3.32 8.23-9.17 8.25q-30 .12-59.92 0c-5.5 0-8.83-3.19-8.88-8 0-5.05 3.35-8.22 9.1-8.25 9.97-.04 19.97 0 29.97 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4331",
    "data-name": "Path 4331",
    d: "M251 276.12h-22.95c-3.38 0-6.12-1-6.06-4.9s2.7-5.07 6.08-5.08h45.39c3.59 0 6.53 1.37 6.39 5.31-.14 3.65-3 4.73-6.41 4.68-7.51-.08-14.99-.02-22.44-.01z",
    style: {
      fill: "#fdfdfd"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPlaceholder);
export default __webpack_public_path__ + "static/media/empty-placeholder.7cd67e7627c37a5cbab946bde4406c89.svg";
export { ForwardRef as ReactComponent };